// User-level check permissions are carried as scopes on the HR user, mirrored from
// the Cognito token (custom:scopes) that fetch-auth-user reads. Legacy users created
// before per-user permissions existed have neither "pre_check" nor "background_check"
// and are treated as allowed for both (falling back to company-level permission).
const PRE_CHECK_SCOPE = "pre_check"
const BACKGROUND_CHECK_SCOPE = "background_check"
// Billing/payment administration for the company. Explicit only — never legacy-granted —
// so pre-existing HR users are not silently given billing access.
const COMPANY_ADMIN_SCOPE = "company_admin"

const isLegacy = (scopes) => {
    const list = scopes || []
    return !list.includes(PRE_CHECK_SCOPE) && !list.includes(BACKGROUND_CHECK_SCOPE)
}

export const hasPreCheckAccess = (scopes) =>
    isLegacy(scopes) || (scopes || []).includes(PRE_CHECK_SCOPE)

export const hasBackgroundCheckAccess = (scopes) =>
    isLegacy(scopes) || (scopes || []).includes(BACKGROUND_CHECK_SCOPE)

export const hasCompanyAdminAccess = (scopes) =>
    (scopes || []).includes(COMPANY_ADMIN_SCOPE)

// Internal (admin portal) scopes. A FINANCE user holds "finance" without "admin": the admin portal
// then shows only the finance pages (clients -> invoices -> TruChecks), read-only.
const ADMIN_SCOPE = "admin"
const FINANCE_SCOPE = "finance"

export const hasAdminAccess = (scopes) => (scopes || []).includes(ADMIN_SCOPE)

export const hasFinanceAccess = (scopes) => (scopes || []).includes(FINANCE_SCOPE)

// Finance and nothing else that uses the admin portal — gets the finance-only portal.
export const isFinanceOnly = (scopes) => hasFinanceAccess(scopes) && !hasAdminAccess(scopes)
